import PropTypes from "prop-types";

import { defineMessages, injectIntl, FormattedMessage } from "react-intl";

import { Helmet } from "react-helmet";

import ImmutablePropTypes from "react-immutable-proptypes";
import ImmutablePureComponent from "react-immutable-pure-component";
import { connect } from "react-redux";

import { debounce } from "lodash";

import { fetchMutes, expandMutes } from "flavours/glitch/actions/mutes";
import ColumnHeader from "flavours/glitch/components/column_header";
import PageFrame from "flavours/glitch/features/ui/components/page_frame";
import { LoadingIndicator } from "flavours/glitch/components/loading_indicator";
import ScrollableList from "flavours/glitch/components/scrollable_list";
import AccountContainer from "flavours/glitch/containers/account_container";




const messages = defineMessages({
  heading: { id: "column.mutes", defaultMessage: "Muted users" },
});

const mapStateToProps = state => ({
  accountIds: state.getIn(["user_lists", "mutes", "items"]),
  hasMore: !!state.getIn(["user_lists", "mutes", "next"]),
  isLoading: state.getIn(["user_lists", "mutes", "isLoading"], true),
});

class Mutes extends ImmutablePureComponent {

  static propTypes = {
    params: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    hasMore: PropTypes.bool,
    isLoading: PropTypes.bool,
    accountIds: ImmutablePropTypes.list,
    intl: PropTypes.object.isRequired,
    multiColumn: PropTypes.bool,
    embedded: PropTypes.bool,
  };

  UNSAFE_componentWillMount () {
    this.props.dispatch(fetchMutes());
  }

  handleLoadMore = debounce(() => {
    this.props.dispatch(expandMutes());
  }, 300, { leading: true });

  render () {
    const { intl, accountIds, hasMore, multiColumn, embedded, isLoading } = this.props;
    const title = intl.formatMessage(messages.heading);

    if (!accountIds) {
      return (
        <PageFrame embedded={embedded}>
          <LoadingIndicator />
        </PageFrame>
      );
    }

    const emptyMessage = <FormattedMessage id='empty_column.mutes' defaultMessage="You haven't muted any users yet." />;

    return (
      <PageFrame embedded={embedded} bindToDocument={!multiColumn} label={title}>
        <ColumnHeader icon='bell-slash' title={title} multiColumn={multiColumn} showBackButton />
        <ScrollableList
          scrollKey='mutes'
          onLoadMore={this.handleLoadMore}
          hasMore={hasMore}
          isLoading={isLoading}
          emptyMessage={emptyMessage}
          bindToDocument={!multiColumn && !embedded}
        >
          {accountIds.map(id =>
            <AccountContainer key={id} id={id} defaultAction='mute' />,
          )}
        </ScrollableList>

        <Helmet>
          <meta name='robots' content='noindex' />
        </Helmet>
      </PageFrame>
    );
  }

}

export default connect(mapStateToProps)(injectIntl(Mutes));
